module.exports = __webpack_public_path__ + "img/icon_map_61_off_101.9e4bbaeb.png";